import React, { useState } from "react";
import img1 from "../../assets/images/home/HowListenAuraWorksImg1.webp";
import img2 from "../../assets/images/home/HowListenAuraWorksImg2.webp";
import img3 from "../../assets/images/home/HowListenAuraWorksImg3.webp";

export const HowListenAuraWorks = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const cards = [
    {
      title: "Sign Up Anonymously",
      text: "Create your account without sharing personal details. Your privacy is our promise.",
      img: img1,
    },
    {
      title: "Choose Your Mode",
      text: "Pick chat, voice, or in-person session. In-person sessions can be scheduled at available locations.",
      img: img2,
    },
    {
      title: "Connect Instantly",
      text: "Get matched with a trained listener and start your session in real time.",
      img: img3,
    },
  ];

  return (
    <div className="HowListenAuraWorksSection">
      <div className="HowListenAuraWorksContent">
        <h2>How Listen Aura Works</h2>
        <p>
          Getting started is simple — your comfort is just a few steps away.
        </p>
      </div>

      <div className="HowListenAuraWorksGrid">
        <div className="gridLeft">
          {cards.map((card, index) => (
            <div
              key={index}
              className={`cardgrid ${activeIndex === index ? "active" : ""}`}
              onClick={() => setActiveIndex(index)}
            >
              <div className="cardTitle">{card.title}</div>
              <div className="cardText">{card.text}</div>
            </div>
          ))}
        </div>

        {/* Right Column */}
        <div className="gridRight">
          <img src={cards[activeIndex].img} alt={`step-${activeIndex + 1}`} />
        </div>
      </div>
    </div>
  );
};
